<template>
  <div class="config-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>配置管理</span>
        <el-button type="primary" size="small" @click="showAddDialog">添加配置</el-button>
      </div>

      

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="key" label="键名" min-width="200" />
        <el-table-column prop="value" label="值" min-width="200">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.value && scope.row.value.length > 20" effect="dark" :content="scope.row.value" placement="top">
              <span>{{ scope.row.value.substring(0, 20) }}...</span>
            </el-tooltip>
            <span v-else>{{ scope.row.value || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="200" />
        <el-table-column prop="updated_at" label="更新时间" width="180" />
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog 
      :title="dialogType === 'add' ? '添加配置' : '编辑配置'" 
      :visible.sync="dialogVisible" 
      width="500px"
      @closed="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="键名" prop="key" v-if="dialogType === 'add'">
          <el-input v-model="form.key" placeholder="请输入配置键名" />
        </el-form-item>
        <el-form-item v-else label="键名">
          <el-input v-model="form.key" :disabled="true" />
        </el-form-item>
        
        <el-form-item label="值" prop="value">
          <el-input 
            v-model="form.value" 
            type="textarea" 
            :rows="4" 
            placeholder="请输入配置值" 
          />
        </el-form-item>
        
        <el-form-item label="描述">
          <el-input 
            v-model="form.description" 
            type="textarea" 
            :rows="2" 
            placeholder="请输入配置描述（可选）" 
          />
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

function formatDateArray (arr) {
  if (!Array.isArray(arr) || arr.length < 6) return ''
  const [y, M, d, h, m, s] = arr
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${y}-${pad(M)}-${pad(d)} ${pad(h)}:${pad(m)}:${pad(s)}`
}

export default {
  name: 'ServiceStatement',
      data() {
        return {
          loading: false,
          submitting: false,
          dialogVisible: false,
          dialogType: 'add', // 'add' or 'edit'
          list: [],
          form: {
            key: '',
            value: '',
            description: ''
          },
      rules: {
        key: [
          { required: true, message: '请输入配置键名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入配置值', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    // 获取配置列表
    async fetchList() {
      try {
        this.loading = true
        // 根据文档，获取所有配置项列表
        const result = await http.get('/api/configs')
        let items = []
        // http 封装会直接返回 data，因此这里兼容数组或分页对象
        if (Array.isArray(result)) {
          items = result
        } else if (result && Array.isArray(result.items)) {
          items = result.items
        } else {
          items = []
        }
        this.list = items.map(item => ({
          id: item.id,
          key: item.key,
          value: item.value,
          description: item.description || '',
          created_at: formatDateArray(item.createdAt),
          updated_at: formatDateArray(item.updatedAt)
        }))
      } catch (error) {
        console.error('获取配置列表失败:', error)
        this.$message.error('获取配置列表失败')
      } finally {
        this.loading = false
      }
    },

    

    

    // 显示添加对话框
    showAddDialog() {
      this.dialogType = 'add'
      this.dialogVisible = true
    },

    // 编辑配置
    handleEdit(row) {
      this.dialogType = 'edit'
      this.form = {
        key: row.key,
        value: row.value,
        description: row.description || ''
      }
      this.dialogVisible = true
    },

    // 删除配置
    handleDelete(row) {
      this.$confirm(`确定要删除配置项 "${row.key}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await http.delete(`/api/configs/${row.key}`)
          this.$message.success('删除成功')
          this.fetchList()
        } catch (error) {
          console.error('删除配置失败:', error)
          this.$message.error('删除配置失败')
        }
      }).catch(() => {})
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          if (this.dialogType === 'add') {
            // 添加配置项
            const params = {
              key: this.form.key,
              value: this.form.value,
              description: this.form.description || ''
            }
            await http.post('/api/configs', params)
          } else {
            // 更新配置项
            const params = {
              value: this.form.value
            }
            // 如果描述有变化，才发送描述字段
            if (this.form.description !== undefined) {
              params.description = this.form.description
            }
            await http.put(`/api/configs/${this.form.key}`, params)
          }

          this.$message.success(this.dialogType === 'add' ? '添加成功' : '更新成功')
          this.dialogVisible = false
          this.fetchList()
        } catch (error) {
          console.error('操作失败:', error)
          this.$message.error(this.dialogType === 'add' ? '添加失败' : '更新失败')
        } finally {
          this.submitting = false
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        key: '',
        value: '',
        description: ''
      }
    }
  }
}
</script>

<style scoped>
.config-manage {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 20px;
}

.pager {
  margin-top: 20px;
  text-align: right;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 10px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
